import EventBus from '../../Shared/Assets/event-bus';

(function ($, window) {
  let adTileElement = "[data-mm-ad-tile]";

  $(function () {
    new EventBus().handle("ProcessMediaMotiveAdTile", processMediaMotiveAdTile);
  });

  let processMediaMotiveAdTile = function () {
    $(adTileElement).each(function () {
      if(this.getAttribute("data-init")) 
        return;

      if (!this.id) {
        this.id = "elm"+getRandomValue();
      }
      let isKruxRequired = (this.getAttribute('data-krux-required') === 'True');
      let tags = getTags();

      let scriptUrl = this.getAttribute('data-media-motive-url');
      if (isKruxRequired) {
        scriptUrl = scriptUrl + tags.sasTags;
      }
      scriptUrl = scriptUrl + tags.gaTags;

      let theElm = this;
      window.postscribe(this, '<script src=\'' + scriptUrl + '\'><\/script>', {
        done: function () {
          theElm.style.background = "none";
        }
      });
      this.setAttribute("data-init", true);
    });
  };

  function getRandomValue() {
    return Math.round(Math.random() * (new Date()).getTime());
  }

  function getTags() {
    if (window.KruxSasHelper) {
      return {
        sasTags : '/' + window.KruxSasHelper().getSasTags(),
        gaTags : window.KruxSasHelper().getGaTags()
      }
    } else {
      if (console) {
        console.warn('KruxSasHelper not loaded');
      }
      return {
        sasTags: "",
        gaTags: ""
      }
    }
  }
})(jQuery, window)